
import { ShoppingBag } from "lucide-react";
import { SocialProfile } from "../../types";

interface EmptyStateProps {
  selectedProfileObjects?: SocialProfile[];
  noProfiles?: boolean;
}

const EmptyState = ({ selectedProfileObjects = [], noProfiles }: EmptyStateProps) => {
  if (noProfiles) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center p-6 bg-pastel-blueLight dark:bg-[#121624]">
        <ShoppingBag className="h-16 w-16 text-custom-primary dark:text-custom-secondaryLight mb-4 opacity-70" />
        <h3 className="text-lg font-medium text-custom-dark dark:text-gray-200 mb-2 font-sans">
          Aucun profil sélectionné
        </h3>
        <p className="text-gray-600 dark:text-gray-400 font-sans">
          Veuillez sélectionner un profil pour voir les contenus associés.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-6 bg-pastel-blueLight dark:bg-[#121624]">
      <ShoppingBag className="h-16 w-16 text-custom-primary dark:text-custom-secondaryLight mb-4 opacity-70" />
      <h3 className="text-lg font-medium text-custom-dark dark:text-gray-200 mb-2 font-sans">
        Aucun contenu disponible
      </h3>
      <p className="text-gray-600 dark:text-gray-400 font-sans">
        Aucun contenu n'a été trouvé pour {selectedProfileObjects.map(p => p.name).join(", ")}.
      </p>
    </div>
  );
};

export default EmptyState;
